import React from 'react'
import { Done } from '@mui/icons-material'
import { FloatButton, Modal } from 'antd'
import { LinkOutlined, SpotifyFilled, YoutubeFilled } from '@ant-design/icons'
import { ReactComponent as SoundCloud } from './../../../assets/images/soundcloud.svg'
import './musicianSocialLinks.css'
import CustomInput from '../../../Primitives/input'
import { useAtom } from 'jotai'
import { useAuth0 } from '@auth0/auth0-react'
import { myUserAtom } from '../../../State/Musician/myUserAtom'
import userClient from '../../../Api/Lirari/Clients/userClient'

const MusicianSocialLinks = ({ editMode }: { editMode: boolean }) => {
  const [isModalOpen, setIsModalOpen] = React.useState(false)
  const [myUser, setMyUser] = useAtom(myUserAtom)
  const { isAuthenticated, getAccessTokenSilently } = useAuth0()

  const handleUpdateEmail = async () => {
    if (isAuthenticated) {
      await userClient.updateUser(
        myUser.id,
        {
          youTubeUrl: myUser.socialLinks.youtube,
          soundCloudUrl: myUser.socialLinks.soundCloud,
          spotifyUrl: myUser.socialLinks.spotify,
        },
        await getAccessTokenSilently({
          authorizationParams: {
            scope: 'user:all',
          },
        }),
      )
    }
    setIsModalOpen(false)
  }

  const EditLinksModal = (
    <Modal centered open={isModalOpen} closable={false} footer={[]}>
      <div className="flex flex-col items-center">
        <CustomInput
          value={myUser.socialLinks.youtube}
          placeholder="Youtube"
          onChange={(e) => setMyUser({ ...myUser, socialLinks: { ...myUser.socialLinks, youtube: e.target.value } })}
        />
        <CustomInput
          value={myUser.socialLinks.spotify}
          placeholder="Spotify"
          onChange={(e) => setMyUser({ ...myUser, socialLinks: { ...myUser.socialLinks, spotify: e.target.value } })}
        />
        <CustomInput
          value={myUser.socialLinks.soundCloud}
          placeholder="Sound Cloud"
          onChange={(e) => setMyUser({ ...myUser, socialLinks: { ...myUser.socialLinks, soundCloud: e.target.value } })}
        />
        <button
          className="flex p-0 mt-2.5 justify-center items-center min-w-12 min-h-12 rounded-full bg-white hover:bg-[#cdcdcd]/90 [&>svg]:text-black"
          onClick={handleUpdateEmail}
        >
          <Done />
        </button>
      </div>
    </Modal>
  )

  return editMode || myUser.socialLinks ? (
    <div onClick={() => (editMode && !isModalOpen ? setIsModalOpen(true) : null)}>
      {!editMode ? (
        <FloatButton.Group
          className="lg:absolute lg:right-0 lg:bottom-1 [*>svg]:text-black"
          trigger="click"
          type="default"
          icon={<LinkOutlined className="size-6 [&>svg]:size-6 text-black [&>svg]:text-black" />}
        >
          {myUser.socialLinks.youtube ? (
            <a
              href={
                myUser.socialLinks.youtube.startsWith('http')
                  ? myUser.socialLinks.youtube
                  : `https://${myUser.socialLinks.youtube}`
              }
              target="_blank"
              rel="noopener noreferrer"
            >
              <FloatButton
                className="size-12 mb-4 bg-white hover:bg-[#cdcdcd]/90"
                icon={<YoutubeFilled className="size-6 [&>svg]:size-6 [&>svg]:text-black" />}
              />
            </a>
          ) : null}

          {myUser.socialLinks.spotify ? (
            <a
              href={
                myUser.socialLinks.spotify.startsWith('http')
                  ? myUser.socialLinks.spotify
                  : `https://${myUser.socialLinks.spotify}`
              }
              target="_blank"
              rel="noopener noreferrer"
            >
              <FloatButton
                className="size-12 mb-4 bg-white hover:bg-[#cdcdcd]/90"
                icon={<SpotifyFilled className="size-6 [&>svg]:size-6 [&>svg]:text-black" />}
              />
            </a>
          ) : null}

          {myUser.socialLinks.soundCloud ? (
            <a
              href={
                myUser.socialLinks.soundCloud.startsWith('http')
                  ? myUser.socialLinks.soundCloud
                  : `https://${myUser.socialLinks.soundCloud}`
              }
              target="_blank"
              rel="noopener noreferrer"
            >
              <FloatButton
                className="size-12 mb-4 bg-white hover:bg-[#cdcdcd]/90"
                icon={<SoundCloud className="size-6 [&>svg]:size-6 [&>svg]:text-black" />}
              />
            </a>
          ) : null}
        </FloatButton.Group>
      ) : (
        <a className="lg:absolute lg:right-0 lg:bottom-1">
          <LinkOutlined className="flex p-0 justify-center items-center min-w-[50px] min-h-[50px] size-[50px] rounded-full bg-white hover:bg-[#cdcdcd]/90 cursor-pointer [&>svg]:size-6 [&>svg]:text-black" />
        </a>
      )}

      {EditLinksModal}
    </div>
  ) : null
}

export default MusicianSocialLinks
